//eslint-disable-next-line @typescript-eslint/no-explicit-any
declare const config: any;

export const API_BASE_URL = (config?.VUE_CONFIG_APP_API_BASE_URL as string) || (process.env.VUE_APP_API_BASE_URL as string) || "<API URL>";
export const INSIGHTS_KEY = (config?.VUE_CONFIG_APP_INSIGHTS_KEY as string) || (process.env.VUE_APP_INSIGHTS_KEY as string) || "<APP INSIGHTS KEY>";
export const RECAPTCHA_SITE_KEY = (config?.VUE_CONFIG_APP_RECAPTCHA_SITE_KEY as string) || (process.env.VUE_APP_RECAPTCHA_SITE_KEY as string) || "<RECAPTCHA SITE KEY>";
export const SUSCRIPTION_KEY = (config?.VUE_CONFIG_APP_SUSCRIPTION_KEY as string) || (process.env.VUE_APP_SUSCRIPTION_KEY as string) || "<SUSCRIPTION KEY>";

export const FUNCTION_KEY_MAX_AMOUNT = (config?.VUE_CONFIG_APP_FUNCTION_KEY_MAX_AMOUNT as string) || (process.env.VUE_APP_FUNCTION_KEY_MAX_AMOUNT as string) || "<FUNCTION KEY MAX AMOUNT>";
export const FLOW_VAL_ID_URL = (config?.VUE_CONFIG_APP_FLOW_VAL_ID_URL as string) || (process.env.VUE_APP_FLOW_VAL_ID_URL as string) || "<FLOW VAL ID URL>";
// export const FLOW_VAL_ADDR_URL = (config?.VUE_CONFIG_APP_FLOW_VAL_ADDR_URL as string) || (process.env.VUE_APP_FLOW_VAL_ADDR_URL as string) || "<FLOW VAL ADDR URL>";
export const FLOW_VAL_FACE_URL = (config?.VUE_CONFIG_APP_FLOW_VAL_FACE_URL as string) || (process.env.VUE_APP_FLOW_VAL_FACE_URL as string) || "<FLOW VAL FACE URL>";
export const FLOW_VAL_ID_FRONT_URL = (config?.VUE_CONFIG_APP_FLOW_VAL_ID_FRONT_URL as string) || (process.env.VUE_APP_FLOW_VAL_ID_FRONT_URL as string) || "<FLOW VAL ID FRONT URL>";
export const FLOW_CRED_REQ_PDF_URL = (config?.VUE_CONFIG_APP_FLOW_CRED_REQ_PDF_URL as string) || (process.env.VUE_APP_FLOW_CRED_REQ_PDF_URL as string) || "<FLOW CRED REQ PDF URL>";
export const FLOW_KIT_PDF_URL = (config?.VUE_CONFIG_APP_FLOW_KIT_PDF_URL as string) || (process.env.VUE_APP_FLOW_KIT_PDF_URL as string) || "<FLOW KIT PDF URL>";
export const FLOW_VAL_PREAUTORIZADO = (config?.VUE_CONFIG_APP_FLOW_VAL_PREAUTORIZADO as string) || (process.env.VUE_APP_FLOW_VAL_PREAUTORIZADO as string) || "<FLOW VAL PREAUTORIZADO>";
export const FLOW_VAL_NIP = (config?.VUE_CONFIG_APP_FLOW_VAL_NIP as string) || (process.env.VUE_APP_FLOW_VAL_NIP as string) || "<FLOW VAL NIP>";
export const FLOW_VAL_PHONE = (config?.VUE_CONFIG_APP_FLOW_VAL_PHONE as string) || (process.env.VUE_APP_FLOW_VAL_PHONE as string) || "<FLOW VAL PHONE>";
export const FLOW_VAL_DATE_RELEASE_LETTER =
  (config?.VUE_CONFIG_APP_FLOW_VAL_DATE_RELEASE_LETTER as string) || (process.env.VUE_APP_FLOW_VAL_DATE_RELEASE_LETTER as string) || "<FLOW_VAL_DATE_RELEASE_LETTER>";
export const FLOW_VAL_FILE_URL = (config?.VUE_CONFIG_APP_FLOW_VAL_FILE_URL as string) || (process.env.VUE_APP_FLOW_VAL_FILE_URL as string) || "<FLOW VAL FILE URL>";

export const RETURN_URL = (config?.VUE_CONFIG_APP_RETURN_URL as string) || (process.env.VUE_APP_RETURN_URL as string) || "<URL ID>";
export const TNT_ID = (config?.VUE_CONFIG_APP_TNT_ID as string) || (process.env.VUE_APP_TNT_ID as string) || "<TNT ID>";
export const CTE_ID = (config?.VUE_CONFIG_APP_CTE_ID as string) || (process.env.VUE_APP_CTE_ID as string) || "<CTE ID>";

export const FLOW_SUSCRIPTION = (config?.VUE_CONFIG_APP_FLOW_SUSCRIPTION as string) || (process.env.VUE_APP_FLOW_SUSCRIPTION as string) || "<FLOW SUSCRIPTION>";

export const API_DATE_FORMAT = "YYYY-MM-DD";

export const DEFAULT_LOCALE = (process.env.VUE_APP_I18N_LOCALE as string) || "es";

export const LOCALE_OPTIONS = [
  { id: "en", name: "English" },
  { id: "es", name: "Español" }
] as LocaleOption[];

//DEV
// declare const config: any;
// export const API_BASE_URL = "https://lbt-dev-scus-ams-001.azure-api.net";
// export const INSIGHTS_KEY = "c25034d9-552e-4641-bc7a-0d90bd6ae555";
// export const RECAPTCHA_SITE_KEY = "6LfUlO4ZAAAAABgAYc9DQRn_PLMTdjDGicV_JG2w";
// export const SUSCRIPTION_KEY = "421e02174c834b94997cac168171b5cf";
// export const FUNCTION_KEY_MAX_AMOUNT = "kNUy9gh4rbwFYyzwheo90bNwESQl27wVob0-xsXcyywXAzFuDrd9Jw==";
// export const FLOW_VAL_ID_URL = "30078b5fcb3241d99fd0d94047b66f89";
// // export const FLOW_VAL_ADDR_URL = "16f537c29b4141a49040c0b602a00549";
// export const FLOW_VAL_FACE_URL = "70b0cac1f49443d89c4256945a610a9d";
// export const FLOW_VAL_ID_FRONT_URL = "5a934cfb57e6411bb4b6c75a09d36661";
// export const FLOW_CRED_REQ_PDF_URL = "da973cb1dcb74d9380ee91566325ee6e";
// export const FLOW_KIT_PDF_URL = "17dd3c190a7745a1ac9c6a57f4c596cc";
// export const FLOW_VAL_PREAUTORIZADO = "d2af65847ecc45ad85469a4ffc758a67";
// export const FLOW_VAL_NIP = "7cdab5eaf0ec417e8f4e31224e23abcc";
// export const FLOW_VAL_PHONE = "c2a937838661475da0a0f0ea634515be";
// export const FLOW_VAL_DATE_RELEASE_LETTER = "5dc943642b4744f990053ba4860cfb64";
// export const FLOW_VAL_FILE_URL = "eef742b812e14f9085e7e83d1311b223";
// export const RETURN_URL = "http://localhost:8080/";
// export const TNT_ID = "46e38439-7e43-4566-bc44-b305c3c2b23e";
// export const CTE_ID = "37dfc6f1-7e0a-4ace-ad34-ce661afebd3a";
// export const FLOW_SUSCRIPTION = "https://f3fb051b851b41219edb3099ca6d0c.ad.environment.api.powerplatform.com:443/powerautomate/automations/direct/workflows/a3f74fb88e834e24a28c175d18fff818/triggers/manual/paths/invoke?api-version=1%26sp=%2Ftriggers%2Fmanual%2Frun%26sv=1.0%26sig=3u2NXl59WLJUO4SvV3S1QbjB8ROQ90-_u44V4FuwrI4";
// export const API_DATE_FORMAT = "YYYY-MM-DD";
// export const DEFAULT_LOCALE = (process.env.VUE_APP_I18N_LOCALE as string) || "es";
// export const LOCALE_OPTIONS = [
//   { id: "en", name: "English" },
//   { id: "es", name: "Español" }
// ] as LocaleOption[];

// QA
/*declare const config: any;
 export const API_BASE_URL = "https://lbt-qa-scus-ams-001.azure-api.net";
 export const INSIGHTS_KEY = "40956654-2f12-47e4-9893-e720584f0cdb";
 export const RECAPTCHA_SITE_KEY = "6LfUlO4ZAAAAABgAYc9DQRn_PLMTdjDGicV_JG2w";
 export const SUSCRIPTION_KEY = "e3cd619f9d21421a8665e04ea99283cd"
 export const FUNCTION_KEY_MAX_AMOUNT = "kNUy9gh4rbwFYyzwheo90bNwESQl27wVob0-xsXcyywXAzFuDrd9Jw==";
 export const FLOW_VAL_ID_URL = "195a2d91353943378939a3458e3b280b";
 // export const FLOW_VAL_ADDR_URL = "13cb2641b9d54a13bd58547b2f3809fb";
 export const FLOW_VAL_FACE_URL = "d8cf9f5430784d968e520397530d2207";
 export const FLOW_VAL_ID_FRONT_URL = "2b2eed27bac54c738039cb05f8202c6c";
 export const FLOW_CRED_REQ_PDF_URL = "ad87f93c5e66472f953fda7a25a13804";
 export const FLOW_KIT_PDF_URL = "d2938f7ed1e049ad99c4518919db002e";
 export const FLOW_VAL_PREAUTORIZADO = "a2ec18177b714350960b739909bf5ae5";
 export const FLOW_VAL_NIP = "1f8ad4c81eb04ba6a837a35bb19c8e78";
 export const FLOW_VAL_PHONE = "79492b5a44244b6f80135354ba7d9a32";
 export const FLOW_VAL_DATE_RELEASE_LETTER = "133db7fe8fa048038821ebce61c6a012";
 export const FLOW_VAL_FILE_URL = "464617d9095c4163a3f416cdd9c42241";
 export const RETURN_URL = "http://localhost:8080/";
 export const TNT_ID = "46e38439-7e43-4566-bc44-b305c3c2b23e";
 export const CTE_ID = "0d16c54c-470a-422c-b6da-5cbad7911149";
 export const FLOW_SUSCRIPTION = "https://42f7d0554e8144eb9d0821c439c417.b0.environment.api.powerplatform.com:443/powerautomate/automations/direct/workflows/b2117902b09042f4bddf2bd85debc32c/triggers/manual/paths/invoke?api-version=1%26sp=%2Ftriggers%2Fmanual%2Frun%26sv=1.0%26sig=dyPO449yeCp4KVG0JWMEiWaEnz5eDQ2-gMFcUFdP544";
 export const API_DATE_FORMAT = "YYYY-MM-DD";
 export const DEFAULT_LOCALE = (process.env.VUE_APP_I18N_LOCALE as string) || "es";
 export const LOCALE_OPTIONS = [
   { id: "en", name: "English" },
   { id: "es", name: "Español" }
 ] as LocaleOption[];*/
